import * as posModels from "./posModels";
import instance from "./instance";
import {settings as urls} from "./urls";

// if the storedDeviceId is not null, the backend echoes it back.
export function get(): Promise<posModels.Settings> {
    return instance
        .request({
            url: urls.get,
            method: "GET",
        })
        .then((response) => response.data);
}

export function recordChangeStationMode(
    stationMode: posModels.StationMode,
    laneAssignment: posModels.LaneAssignment | null,
): Promise<void> {
    return instance
        .request({
            url: urls.recordStation,
            method: "POST",
            data: {
                stationMode,
                laneAssignment,
            },
        })
        .then((response) => response.data);
}

export function getKioskCash(): Promise<posModels.KioskCashResponse> {
    return instance
        .request({
            url: urls.kioskCash,
            method: "GET",
        })
        .then((response) => response.data);
}

export function setKioskCash(pagerNumber: number | null): Promise<void> {
    return instance
        .request({
            url: urls.kioskCash,
            method: "POST",
            data: {pagerNumber},
        })
        .then((response) => response.data);
}
